module.exports = __webpack_public_path__ + "static/media/choreography.79c1efc5.JPG";